<i18n>
{
  "en": {
    "title": "TsumTsum configuration page",
    "encrypted": "Line account is email address instead of ID. Line Account/Password will be encrypted.",
    "show_advanced_config": "Show advanced config",
    "hide_advanced_config": "Hide advanced config",
    "still_have_not_bind_with_email": "Have not bound with your email or do not know how to?",
    "bind_email_tutorial": "Click here for tutorial from LINE official",
    "double_confirm_two_factor_auth_not_enabled": "Please confirm 'Two-factor authentication' is DISABLED in Line app. (Default is disabled)",
    "recommend_keeping_default": "The best parameters have been tuned for you, suggesting that modify advanced settings only it if you know what you are doing",
    "auto_fix": "When recordFolderId was set, Receive One Item must be true. We will automatically fix it for you.",
    "auto_fix2": "While auto play is enabled, playing games will reset the friend list, thus conflicting the 'send heart max duration'. Thus 'send heart max duration' will be set to 0.",
    "current_is": "current is",
    "line_account_and_password_are_must": "Line account(email) and password are required!",
    "invalid_email": "Invalid e-mail.",
    "save": "Save",
    "cancel": "Cancel",
    "reset": "Reset",
    "yes": "Yes",
    "no": "No",
    "required": "required",
    "enableRecord": "Heart Record"
  },
  "zhHant": {
    "title": "TsumTsum 設定頁面",
    "encrypted": "Line的帳號為email，請不要輸入Line ID。帳號與密碼將會被加密。",
    "show_advanced_config": "顯示進階設定",
    "hide_advanced_config": "隱藏進階設定",
    "still_have_not_bind_with_email": "還沒有綁定或不知道如何綁定你的email嗎？",
    "bind_email_tutorial": "點擊這裡看LINE官方教學",
    "double_confirm_two_factor_auth_not_enabled": "請確認Line雙重驗證功能是關閉的(預設是關閉)。",
    "recommend_keeping_default": "我們已為您設置好最佳進階設定，建議保持預設值即可",
    "auto_fix": "當設定啟用接收愛心紀錄時，一顆一顆接收愛心的選項必須啟用，否則無法紀錄，我們會自動為您啟用此選項",
    "auto_fix2": "當啟用自動玩時，每次玩遊戲後朋友頁面位置會重置，會與設定送心時間上限發生衝突，我們自動幫您把送心時間上限改成0",
    "current_is": "現在是",
    "line_account_and_password_are_must": "請輸入Line的帳號密碼",
    "invalid_email": "無效的email",
    "save": "存檔",
    "cancel": "不存檔退出",
    "reset": "重置",
    "yes": "是",
    "no": "否",
    "required": "必須",
    "enableRecord": "收心紀錄"
  },
  "ja": {
    "title": "ツムツム操作ページ",
    "encrypted": "LINEアカウントはメールです。ご注意ください。LINEのアカウントとパスワードは暗号化されますのでご安心ください。",
    "show_advanced_config": "詳細設定を開く",
    "hide_advanced_config": "詳細設定を閉じる",
    "still_have_not_bind_with_email": "メールアドレスを登録するには？",
    "bind_email_tutorial": "こちらをクリックして、LINE公式をご覧下さい！",
    "double_confirm_two_factor_auth_not_enabled": "LINEのWebログイン2要素認証「オフ」をご確認ください。（デフォルトはオフです）",
    "recommend_keeping_default": "詳細設定はよくご理解の上変更ください。",
    "auto_fix": "ハート送信数のレコード機能(google drive URL)を使う時は、ハートを個別受け取りに設定してください！",
    "auto_fix2": "自動プレイしたら、ランキングも更新されました。つまり、ツム友さんの順番が変更され、送信も影響されました。送信効率影響されないの為、自動プレイしたら、送信時間上限は0に固定されます。それからランキングの第一位から最後まで送信できます。",
    "current_is": "今は",
    "line_account_and_password_are_must": "LINE アカウントとパスワードでログインしてください",
    "invalid_email": "無効なメール",
    "save": "セーブ",
    "cancel": "キャンセル",
    "reset": "リセット",
    "yes": "はい",
    "no": "いいえ",
    "required": "必要",
    "enableRecord": "ハート受信記録"
  },
  "ko": {
    "title": "썸썸 설정 페이지입니다",
    "encrypted": "Line의 계정은 email이므로 Line ID를 입력하지 마십시오.계정과 비밀번호는 암호화될 것입니다.",
    "show_advanced_config": "단계별 설정을 표시합니다",
    "hide_advanced_config": "단계 설정을 숨깁니다",
    "still_have_not_bind_with_email": "당신의 email을 어떻게 연결할지 아직 설정하지 않았거나 모르십니까?",
    "bind_email_tutorial": "LINE 공식 웹사이트를 보려면 여기를 클릭하세요.",
    "double_confirm_two_factor_auth_not_enabled": "LINE의 Web 로그인 2단계 인증 「끄기」를 확인해 주세요.",
    "recommend_keeping_default": "우리는 이미 당신을 위해 최적의 단계를 설정하였습니다. 미리 설정한 값을 유지하시면 됩니다",
    "auto_fix": "이 설정을 사용하면, 하트 받는 설정을 하나씩 사용해야 합니다. 그렇지 않으면 자동으로 이 설정을 사용합니다.",
    "auto_fix2": "자동으로 게임을 시작할 때, 게임을 할 때마다 친구 페이지 위치가 초기화되어 전송 시간 상한선을 설정하는 것과 충돌합니다. 자동으로 0으로 변경해 드리겠습니다.",
    "current_is": "지금은",
    "line_account_and_password_are_must": "Line의 계정 비밀번호를 입력하세요",
    "invalid_email": "잘못된 이메일입니다",
    "save": "저장",
    "cancel": "취소",
    "reset": "초기화",
    "yes": "네",
    "no": "아니요",
    "required": "꼭 필요합니다",
    "enableRecord": "받은하트 기록"
    }
}
</i18n>

<template>
  <div>
    <div v-show="!isLicenseFound">OOPS! This license cannot be found!</div>
    <v-card flat v-show="isLicenseFound">
      <v-card-title class="headline">{{ $t('title') }}</v-card-title>
      <v-card-text>
        <v-alert :value="true" type="warning" outline>
          {{ $t('encrypted') }}
          <v-divider class="my-2 warning" style="opacity: 0.22"></v-divider>
          {{ $t('still_have_not_bind_with_email') }}
          <a href="https://help.line.me/line/ios/?contentId=20000059" target="_blank"
            class="warning--text font-weight-medium">{{ $t('bind_email_tutorial') }}</a>
        </v-alert>
        <v-alert :value="true" type="success" outline>
          {{ $t('double_confirm_two_factor_auth_not_enabled') }}
        </v-alert>
      </v-card-text>
      <v-card-text>
        <v-flex v-show="showAdvancedConfig || item.basic" xs12 sm12 md12 v-for="(item, key) in localTaskConfig"
          :key="key">
          <v-switch v-if="typeof item.value === 'boolean'" v-model="item.value"
            :readonly="item.disallowTrial === true && license.type === 'trial'"
            :label="`${item.title[$i18n.locale]}: ${item.value ? $i18n.t('yes') : $i18n.t('no')}`">
            <template v-slot:prepend v-if="item.help">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                </template>
                {{ item.help[$i18n.locale] }}
              </v-tooltip>
            </template>
          </v-switch>

          <div v-else-if="key === 'recordFolderId'">
            <v-switch v-model="enableRecord"
              :label="`${$t('enableRecord')}: ${enableRecord ? $i18n.t('yes') : $i18n.t('no')}`">
              <template v-slot:prepend v-if="item.help">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                  </template>
                  {{ item.help[$i18n.locale] }}
                </v-tooltip>
              </template>
            </v-switch>
            <v-text-field v-if="enableRecord" v-model="newRecordId" :label="item.title[$i18n.locale]" readonly
              append-outer-icon="mdi-restart" @click:append-outer="onResetRecordIdClick">
            </v-text-field>
          </div>

          <v-text-field v-else v-model="item.value" v-show="item.hidden !== true"
            :type="item.type !== undefined ? item.type : 'text'" :rules="license !== undefined && !isEmpty(license.taskConfig) && license.taskConfig[key] === item.value
                ? []
                : item.rules
              " :validate-on-blur="true" :label="`${item.title[$i18n.locale]}${license !== undefined && !isEmpty(license.taskConfig) && item.type !== 'password'
                ? ', ' + $i18n.t('current_is') + ' ' + license.taskConfig[key]
                : ''
              }`" :clearable="item.clearable">
            <template v-slot:append-outer v-if="item.help">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                </template>
                {{ item.help[$i18n.locale] }}
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-alert v-show="!showAdvancedConfig" :value="true" type="info" outline>{{
          $t('recommend_keeping_default')
          }}</v-alert>
        <v-btn @click="showAdvancedConfig = !showAdvancedConfig" block>{{
          showAdvancedConfig ? $t('hide_advanced_config') : $t('show_advanced_config')
          }}</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-btn color="grey" @click="reset" outline>{{ $t('reset') }}</v-btn>
        <v-spacer />
        <v-btn color="red" outline @click="back">{{ $t('cancel') }}</v-btn>
        <v-btn color="green" @click="save" :disabled="isLoading" :loading="isLoading">{{ $t('save') }}</v-btn>
      </v-card-actions>
      <v-card-title></v-card-title>
    </v-card>
  </div>
</template>


<script>
import firebase from 'firebase/app';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import i18n from '../plugins/i18n';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'configTsum',
  props: {
    license: {
      type: Object,
      required: true,
    },
  },
  data() {
    const validatedRules = {
      required: value => !!value || this.$i18n.t('required'),
      email: value => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || this.$i18n.t('invalid_email');
      },
    };
    const defaultConfig = {
      isJP: {
        value: i18n.locale === 'ja' ? true : false,
        basic: true,
        title: {
          en: 'Is Japan Version',
          zhHant: '是否為日本版',
          ja: '日本版かどうか',
          ko: '일본어 버전인가요?',
        },
        help: {
          en: 'Play Japan Version TsumTsum (Default is Global Version)',
          zhHant: '是否為日本版，預設為國際版',
          ja: '日本版かどうか確認してください。デフォルトは海外版です',
          ko: '일본어 버전인가요?국제버전으로 예설합나다',
        },
      },
      lineAccount: {
        value: '',
        rules: [validatedRules.email],
        basic: true,
        clearable: true,
        title: {
          en: 'Line Account (should be an email address)',
          zhHant: 'Line帳號 (請填email)',
          ja: 'LINE アカウント (メールアドレスを入力してください)',
          ko: 'Line 계정 (email을 입력하세요)',
        },
        help: {
          en: 'this should be an email address instead of Line ID (Line Account will be encrypted. And seems like random numbers)',
          zhHant: '此欄位為email而不是Line ID (Line帳號將會經過加密處理，亂碼屬正常現象)',
          ja: 'こちらはLINE IDではなく、メールを入力してください (LINEアカウントは暗号化されますので、文字化けしたコードは正常です)',
          ko: '이 위치는 Line ID가 아닌 email 입니다(Line 계정은 암호화 처리되며, 난코드는 정상입니다)',
        },
      },
      linePassword: {
        value: '',
        rules: [validatedRules.required],
        basic: true,
        clearable: true,
        type: 'password',
        title: {
          en: 'Line Password',
          zhHant: 'Line密碼',
          ja: 'LINE パスワード',
          ko: '라인 비밀번호입니다',
        },
        help: {
          en: 'Line Password will be encrypted. And seems like random numbers',
          zhHant: 'Line帳號將會經過加密處理，亂碼屬正常現象（請確認是否正確）',
          ja: 'LINEアカウントは暗号化されますので、文字化けしたコードは正常です',
          ko: 'Line 계정은 암호화 처리되며, 난코드는 정상적인 현상입니다(정확한지 확인 바랍니다)',
        },
      },
      autoPlay: {
        value: false,
        basic: true,
        title: {
          en: 'Auto Play',
          zhHant: '自動玩遊戲',
          ja: 'ゲームプレイ自動化',
          ko: '자동게임운행',
        },
        help: {
          en: 'Enable auto play game task',
          zhHant: '是否開啟自動玩遊戲功能',
          ja: '自動ゲームプレイ機能を有効にするかどうか',
          ko: '자동으로 게임을 할 지 여부입니다',
        },
      },
      sendHearts: {
        value: true,
        basic: true,
        title: {
          en: 'Auto Send Hearts',
          zhHant: '是否啟用自動送心任務',
          ja: 'ハート送信自動化',
          ko: '자동 하트 발송 작업을 사용할 지 여부입니다',
        },
        help: {
          en: 'Enable auto send hearts task',
          zhHant: '是否開啟自動送心任務',
          ja: 'ハートの自動送信タスクを有効にする',
          ko: '자동 하트 받기 작업을 사용할 지 여부입니다',
        },
      },
      recordFolderId: {
        value: '',
        basic: true,
        title: {
          en: 'Record ID (Autofilled)',
          zhHant: '紀錄ID (自動填寫)',
          ja: '記録ID (オートフィル)',
          ko: '기록 ID (자동 입력)',
        },
        help: {
          en: 'Should send/receive heart be recorded? The record ID will be autofilled. If you want to start a new record, please click the reset button on the right hand side.',
          zhHant: '是否要記錄心心發送/接收狀況。紀錄ID已為您自動填寫，若需開始新的紀錄，請點擊位於右方的重置按鈕',
          ja: 'ハート送信/受信記録を起動するかどうかこちらからどうぞ。レコードのIDが自動に入力されました。新記録を再開する場合、右のリセットボタンを押してください。',
          ko: '하트 자동발송/받기 상황을 기록할 지 여부입니다.기록 ID가 자동 작성되었으므로, 새로운 기록을 시작하려면 오른쪽에 위치한 초기화 버튼을 클릭하십시오',
        },
      },
      buyBox: {
        value: false,
        basic: true,
        disallowTrial: true,
        title: {
          en: 'Auto Buy Box (Subscription only)',
          zhHant: '自動買箱子 (不支援試用版)',
          ja: '自動にBOX購入かどうか (有料版機能)',
          ko: '자동으로 박스 구매를 하다 (시용판은 지원하지 않습니다)',
        },
        help: {
          en: 'Auto Buy Box',
          zhHant: '自動買箱子',
          ja: '自動にBOX購入かどうか',
          ko: '자동으로 박스 구매를 하다 (시용판은 지원하지 않습니다)',
        },
      },
      unlockRoleLevel: {
        value: false,
        basic: true,
        disallowTrial: true,
        title: {
          en: 'Auto Unlock Tsum Level (Subscription only)',
          zhHant: '自動解鎖角色等級 (不支援試用版)',
          ja: '自動にツムレベル上限解放かどうか (有料版機能)',
          ko: '자동으로 썸썸 레벨 잠금 해제 (시용판은 지원하지 않습니다)',
        },
        help: {
          en: 'Auto Unlock Tsum Level',
          zhHant: '自動解鎖角色等級',
          ja: '自動にツムレベル上限解放かどうか',
          ko: '자동으로 썸썸 레벨 잠금 해제 ',
        },
      },
      clearBubbles: {
        value: false,
        title: {
          en: 'Clear Bubbles',
          zhHant: '定期清除泡泡',
          ja: '定期的にボムクリア',
          ko: '주기적으로 거품을 제거합니다',
        },
        help: {
          en: 'Enable auto click/clear bubbles when playing game',
          zhHant: '自動玩遊戲時，是否定時清除泡泡',
          ja: 'ゲーム自動プレイ時に、定期的にボムをクリア',
          ko: '자동으로 게임을 할 때 거품을 제거할 지 여부입니다',
        },
      },
      useFan: {
        value: false,
        title: {
          en: 'Use Fan',
          zhHant: '定期使用風扇',
          ja: '定期的にファンを使う',
          ko: '정기적으로 선풍기를 사용해요',
        },
        help: {
          en: 'Enable auto click/use Fan when playing game',
          zhHant: '自動玩遊戲時，是否定期使用風扇',
          ja: 'ゲーム自動プレイ時に、定期的にファンを使う',
          ko: '자동으로 게임을 할 때 선풍기 정기 사용 여부입니다',
        },
      },
      isFourTsum: {
        value: false,
        title: {
          en: 'Use Four Tsum',
          zhHant: '使用五變四道具',
          ja: '5 ➡️4アイテム',
          ko: '5개를 4개로 바꾼 도구를 사용해요',
        },
        help: {
          en: 'Enable 5to4 prop or not',
          zhHant: '自動玩遊戲時，是否使用五變四道具',
          ja: 'ゲーム自動プレイ時に、5➡️4アイテムを使う',
          ko: '자동으로 게임을 할 때 5개를 4개로 바꾼 도구를 사용할 지 여부입니다.',
        },
      },
      coinItem: {
        value: false,
        title: {
          en: 'Use Coin Prop',
          zhHant: '使用金幣道具',
          ja: 'コインアイテム',
          ko: '코인도구를 사용합나다',
        },
        help: {
          en: 'Enable Coin prop or not',
          zhHant: '自動玩遊戲時，是否使用金錢道具',
          ja: 'ゲーム自動プレイ時に、コインアイテムを使う',
          ko: '자동으로 게임을 할 때 코인도구 사용 여부입니다',
        },
      },
      bubbleItem: {
        value: false,
        title: {
          en: 'Use Bubble Prop',
          zhHant: '使用泡泡道具',
          ja: 'ボムアイテム',
          ko: '거품도구를 사용합나다',
        },
        help: {
          en: 'Enable Bubble Prop or not',
          zhHant: '自動玩遊戲時，是否使用增加泡泡道具',
          ja: 'ゲーム自動プレイ時に、ボムアイテムを使う',
          ko: '자동으로 게임을 할 때거품도구 사용 여부입니다',
        },
      },
      enableAllItems: {
        value: false,
        title: {
          en: 'Enable All Props',
          zhHant: '開/關全部道具',
          ja: 'オン/オフ 全てのアイテムを使う',
          ko: '켜기/닫기 모든 아이템',
        },
        help: {
          en: 'Enable All Props or not',
          zhHant: '自動玩遊戲時，是否使用全部道具',
          ja: 'ゲーム自動プレイ時に、全てのアイテムを使う',
          ko: '자동으로 게임을 할 때 모든 아이템을 사용할 지 여부입니다',
        },
      },
      skillInterval: {
        value: 3,
        hidden: true,
        type: 'number',
        title: {
          en: 'Skill Waiting Time',
          zhHant: '技能等待時間',
          ja: 'スキル発動後の待ち秒数 現在は',
          ko: '기능 대기 시간입니다',
        },
        help: {
          en: 'Watting time after using skill',
          zhHant: '自動玩遊戲時，使用技能後等待/停滯時間',
          ja: 'ゲーム自動プレイ時、ツムツムのスキル発動後の待ち時間()秒',
          ko: '자동으로 게임을 할 때',
        },
      },
      skillLevel: {
        value: 3,
        hidden: true,
        type: 'number',
        title: {
          en: 'Skill Level',
          zhHant: '技能等級',
          ja: 'スキルレベル 現在は',
          ko: '기능 등급입니다',
        },
        help: {
          en: 'The skill level of the role',
          zhHant: '自動玩遊戲時，使用角色的技能等級',
          ja: 'ゲーム自動プレイ時に使うツムツムのスキルレベル',
          ko: '자동으로 게임을 할 때 사용하는 썸썸의 기능 레벨입니다',
        },
      },
      skillType: {
        value: 'burst',
        hidden: true,
        title: {
          en: 'Skill Type',
          zhHant: '技能類型',
          ja: 'スキル種類 現在は',
          ko: '기능 종류입니다',
        },
        help: {
          en: 'Skill type. Default is burst',
          zhHant: '自動玩遊戲時，使用角色的技能類型（沒有在清單內的請選擇消除技能）',
          ja: 'ゲーム自動プレイ時に使うツムツムのスキルタイプ',
          ko: '자동으로 게임을 할 때 사용하는 썸썸의 기능 유형입니다(리스트에 없는 썸썸은 제거기능을 선택하세요)',
        },
      },
      receiveItem: {
        value: false,
        title: {
          en: 'Receive All Items',
          zhHant: '接收全部愛心',
          ja: 'まとめて受け取る',
          ko: '모든 하트를 받습니다',
        },
        help: {
          en: 'Enable receive all hearts task. (Can not record who sent hearts to you)',
          zhHant: '是否啟用一次收全部愛心任務（將無法紀錄收心）',
          ja: '「まとめて受け取る」は「一括受信」機能です。一括受信したら、ルビー保存とハート記録機能が無効になります。',
          ko: '모든 하트 받는 작업을 사용할 지 여부입니다(기록을 세울 수 없게 됩니다)',
        },
      },
      receiveItemInterval: {
        value: 25,
        type: 'number',
        title: {
          en: 'Interval Of Receive All Items',
          zhHant: '接收愛心間隔',
          ja: 'ハート受け取リの間隔',
          ko: '하트 받는 시간 간격을 둡니다',
        },
        help: {
          en: 'Interval (minutes) between receiving all hearts task',
          zhHant: '執行一次收全部愛心任務的時間隔至少間隔（分鐘）',
          ja: 'ハートをまとめて受け取ることを実行する間隔は、最短で（分）です。',
          ko: '모든 하트 받기 간격이에요, 지금은:',
        },
      },
      receiveOneItem: {
        value: true,
        title: {
          en: 'Receive Item One By One',
          zhHant: '一顆一顆接收愛心',
          ja: 'ハートを個別に受け取る',
          ko: '하트를 하나씩 받습니다',
        },
        help: {
          en: 'Enable receive hearts one by one task',
          zhHant: '是否啟用一顆一顆收愛心任務（可啟用紀錄收心）',
          ja: 'ハートを個別に受け取るかどうか(受け取ったハート数を記録できます)',
          ko: '하나씩 하나씩 받는 작업을 시작할 지 여부입니다.(하트받 은 기록 적용 가능)',
        },
      },
      receiveCheckLimit: {
        value: 5,
        type: 'number',
        title: {
          en: 'Repeat receive hearts job for this many times',
          zhHant: '重複檢查收心任務上限次數',
          ja: '受取を複数回繰り返す',
          ko: '',
        },
        help: {
          en: 'The receive hearts page can only show 99 friends at a time. Set higher (5) if you have way more than 99 hearts to receive',
          zhHant: '收心頁面每次只會出現99個人，因此如果有超過99個朋友會送你心的話，建議調高，多收幾次',
          ja: 'ハート受け取りを繰り返す。（1回の受け取り上限は99個までなので、超える場合は増やすことをお勧めします）',
          ko: '',
        },
      },
      receiveOneItemInterval: {
        value: 5,
        type: 'number',
        title: {
          en: 'Interval Of Receive Item One By One',
          zhHant: '收單心間隔',
          ja: '個別受け取リの間隔',
          ko: '하나씩 하나씩 하트 받는 시간 간격을 둡니다',
        },
        help: {
          en: 'Interval (minutes) between receiving hearts one by one task',
          zhHant: '執行一顆一開收愛心任務的時間隔至少間隔（分鐘）',
          ja: 'ハートの個別受け取りを実行する間隔は、最短で（分）です。',
          ko: '하나씩 하나씩 하트 받기 간격이에요, 지금은:',
        },
      },
      receiveSecondItem: {
        value: true,
        title: {
          en: 'Receive Hearts From 2nd Row',
          zhHant: '從第二行開始收心',
          ja: '2行目からハートを受け取る',
          ko: '둘째 줄부터 하트를 받습니다',
        },
        help: {
          en: 'Receive hearts from 2nd row to bypass a mission item at first row inside mailbox',
          zhHant: '因郵箱中第一格出現任務道具而導致卡住收心時，可以試試看打開這個選項',
          ja: 'メールBOXの先頭にあるアイテムで自動受信が止まってしまう場合は、こちらを押してください。',
          ko: '이메일 상자의 첫번째 칸에 작업아이템이 생겨서 심이 끼었을 경우 이 옵션을 열어보세요',
        },
      },
      receiveThirdItem: {
        value: i18n.locale === 'ja' ? true : false,
        title: {
          en: 'Receive Hearts From 3rd Row',
          zhHant: '從第三行開始收心',
          ja: '3行目からハートを受け取る',
          ko: '셋째 줄부터 하트를 받습니다',
        },
        help: {
          en: 'Receive hearts from 3nd row to bypass a mission item at first row inside mailbox',
          zhHant: '因郵箱中第一格出現任務道具而導致卡住收心時，可以試試看打開這個選項',
          ja: 'メールBOXの先頭にあるアイテムで自動受信が止まってしまう場合は、こちらを押してください。',
          ko: '이메일 상자의 첫번째 칸에 작업아이템이 생겨서 심이 끼었을 경우 이 옵션을 열어보세요',
        },
      },
      keepRuby: {
        value: true,
        title: {
          en: 'Keep Ruby',
          zhHant: '保留鑽石',
          ja: 'ルビー保存',
          ko: '다이아몬드를 남겨 둡니다',
        },
        help: {
          en: 'Keep buby or not when receive hearts one by one. (If yes, it will stop hearts receiving task when ruby appeared)',
          zhHant: '收心時是否保留鑽石（是：遇到鑽石會結束收心任務）',
          ja: 'ルビーを受け取るかどうか(はい：メールボックスにルビーを残して受信を一時停止します)',
          ko: '하트 받을 때 다이아몬드가 남아 있는지(예: 다이아몬드를 만나면 임무를 끝냅니다)',
        },
      },
      sentToZero: {
        value: false,
        title: {
          en: 'Send Heart to Zero Score',
          zhHant: '送心給0分',
          ja: '0点に送信',
          ko: '발송으로 0점을 드립니다',
        },
        help: {
          en: 'Whether send heart to friends with zero scores',
          zhHant: '送心任務，是否送心給0分的玩家',
          ja: '0点のツム友にもハートを送信するかどうか',
          ko: '하트 발송 0점을 줄 지 여부입니다',
        },
      },
      sendHeartMaxDuring: {
        value: 0,
        type: 'number',
        title: {
          en: 'Send Heart Max Duration',
          zhHant: '送心時間上限',
          ja: '連続送信時間の上限',
          ko: '하트 발송 시간 상한선입니다',
        },
        help: {
          en: 'Maxium run time of sending heart task. If too many hearts to send, you may want to do other task like receiving hearts',
          zhHant: '執行送心任務的時間上限（分鐘）（如果送心數量太多會卡到收心任務）',
          ja: 'ハート送信の上限時間（分）（ツム友が多すぎる場合、その間ハート受取ができません）',
          ko: '하트 발송 수행 시간 상한선(분) (하트 발송 수가 많으면 걸릴 수 있습니다)',
        },
      },
      sendHeartsInterval: {
        value: 5,
        type: 'number',
        title: {
          en: 'Send Hearts Interval',
          zhHant: '送心完成後休息時間',
          ja: '送信タスクの休み時間',
          ko: '하트 발송을 다하고 쉬는 시간입니다',
        },
        help: {
          en: 'Interval (minutes) between sending hearts task',
          zhHant: '執行送心任務的時間間隔至少（分鐘）',
          ja: 'ハート送信タスクを実行する時間の間隔（分）',
          ko: '발송 하트 받기 간격이에요, 지금은:',
        },
      },
    };
    const recordSetupTutorialLink = {
      en: 'https://sites.google.com/view/robotmonen/xrobotmon#h.p_XPWPEbG36sn8',
      zhHant: 'https://sites.google.com/view/robotmon/xrobotmon#h.p_9b3SrBUw9p5-',
      ja: 'https://sites.google.com/view/robotmonen/xrobotmon#h.p_XPWPEbG36sn8',
    };

    const newRecordId = _.get(this.license, 'taskConfig.recordFolderId', '');

    return {
      isLoading: false,
      defaultConfig: defaultConfig,
      localTaskConfig: cloneDeep(defaultConfig),
      showAdvancedConfig: false,
      recordSetupTutorialLink: recordSetupTutorialLink,
      enableRecord: newRecordId !== '',
      newRecordId,
    };
  },
  created() {
    if (!this.license) {
      this.$router.push({ name: 'home' });
      return;
    }

    const config = this.license.taskConfig;
    if (!isEmpty(config) && Object.keys(config).length > 0) {
      for (const key in config) {
        if (key in this.localTaskConfig) {
          this.localTaskConfig[key].value = config[key];
        } else {
          // These are currently unchangeable setting so ignore them
        }
      }
    }
  },
  computed: {
    // Draw the UI to show if the given licence exist
    isLicenseFound() {
      if (isEmpty(this.license)) {
        return false;
      }
      return true;
    },
  },
  watch: {
    enableRecord(v) {
      if (v && this.newRecordId === '') {
        this.newRecordId = this.genRecordId();
      }
    },
  },
  methods: {
    isEmpty(x) {
      return isEmpty(x);
    },
    back() {
      this.$router.push({ name: 'home' });
    },
    reset() {
      for (const key in this.defaultConfig) {
        if (key === 'lineAccount' || key === 'linePassword') {
          continue;
        }
        this.localTaskConfig[key].value = this.defaultConfig[key].value;
      }
    },
    async save() {
      let configToPost = {
        buyBox: false, // for new feature
        unlockRoleLevel: false, // for new feature
        licenseId: '', // for new feature
        recordDetail: false,
      };
      for (const key in this.localTaskConfig) {
        // check is number type
        if (typeof this.defaultConfig[key].value === 'number') {
          configToPost[key] = +this.localTaskConfig[key].value;
        } else {
          configToPost[key] = this.localTaskConfig[key].value;
        }
      }

      if (_.isEmpty(configToPost.lineAccount) || _.isEmpty(configToPost.linePassword)) {
        alert(this.$i18n.t('line_account_and_password_are_must'));
        return;
      }

      if (this.enableRecord) {
        configToPost.recordFolderId = this.newRecordId;
        configToPost.recordDetail = true;
      } else {
        configToPost.recordFolderId = '';
        configToPost.recordDetail = false;
      }

      if (configToPost.recordFolderId.length && configToPost.receiveOneItem === false) {
        configToPost.receiveOneItem = true;
        alert(this.$i18n.t('auto_fix'));
      }
      if (configToPost.autoPlay && configToPost.sendHeartMaxDuring !== 0) {
        configToPost.sendHeartMaxDuring = 0;
        alert(this.$i18n.t('auto_fix2'));
      }

      this.isLoading = true;

      await firebase.functions().httpsCallable('xPostTaskConfigs')({
        licenseId: this.license.licenseId,
        task: this.license.task || 'tsum-v2',
        taskConfig: configToPost,
      });

      this.isLoading = false;
      this.$router.push({ name: 'home' });
    },
    genRecordId() {
      const licenseId = this.license.licenseId;
      const licensePrefix = licenseId.substr(0, 6);
      const datePrefix = moment().format('YYYYMMDD-HHmm'); // 12
      const randomPrefix = Math.random().toString(36).substr(2, 6);
      const recordId = `${randomPrefix}-${datePrefix}-${licensePrefix}`;
      return recordId;
    },
    onResetRecordIdClick() {
      this.newRecordId = this.genRecordId();
    },
    getFileIdFromDriveUrl(url) {
      // follow example all tested
      // 1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      // https://drive.google.com/folderview?id=1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      // https://drive.google.com/open?id=1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      // https://drive.google.com/drive/folders/1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      url = url + '/';
      const match = url.match(/([a-z0-9_-]{25,})[$/&?]/i);
      return match ? match[1] : '';
    },
  },
};
</script>
